var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderDecore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 152,
    viewBox: "0 0 147 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 115L7.65241 130.53C6.90894 131.429 5.79634 132 4.55269 132C2.31446 132 0.5 130.151 0.5 127.87C0.5 126.232 1.43563 124.817 2.79197 124.149L20.5 115Z",
    fill: "#D9F1F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 135L7.65241 150.53C6.90894 151.429 5.79634 152 4.55269 152C2.31446 152 0.5 150.151 0.5 147.87C0.5 146.232 1.43563 144.817 2.79197 144.149L20.5 135Z",
    fill: "#D9F1F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 135L27.6524 150.53C26.9089 151.429 25.7963 152 24.5527 152C22.3145 152 20.5 150.151 20.5 147.87C20.5 146.232 21.4356 144.817 22.792 144.149L40.5 135Z",
    fill: "#D9F1F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M103.789 88.5111C100.067 87.1611 96.8783 84.9954 94.3504 82.2891C94.3005 82.4434 94.2492 82.5963 94.1926 82.7488C91.6705 89.669 84.0227 93.246 77.1102 90.7394C72.0681 88.9105 68.8111 84.3483 68.3964 79.3281C62.1653 83.5227 54.0918 84.7901 46.5029 82.0377C33.8883 77.4628 27.3932 63.5161 31.9963 50.8874C36.3915 38.8293 49.3138 32.332 61.4533 35.7501C67.2184 25.6219 79.5977 20.8066 90.8997 24.9052C98.8554 27.7905 104.376 34.4044 106.214 42.0635C110.773 40.9061 115.711 41.0551 120.459 42.7768C133.073 47.3517 139.568 61.2984 134.965 73.9271C130.361 86.5566 116.403 93.086 103.789 88.5111Z",
    fill: "#D9F1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderDecore);
export default __webpack_public_path__ + "static/media/headerDecore.dbcc9ef60406b7922890a72a748f9a00.svg";
export { ForwardRef as ReactComponent };